// extracted by mini-css-extract-plugin
export default {"PlayerIds":"PlayerIdContainer_PlayerIds__WFhDW","PlayerIdContainer":"PlayerIdContainer_PlayerIdContainer__eIXTe","IdContainer":"PlayerIdContainer_IdContainer__AQ3cI"};